import { render, staticRenderFns } from "./Historia.vue?vue&type=template&id=7865483c"
import script from "./Historia.vue?vue&type=script&lang=js"
export * from "./Historia.vue?vue&type=script&lang=js"
import style0 from "./Historia.vue?vue&type=style&index=0&id=7865483c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports